<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Tipo de Chamado</div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="col-md-12">
              <form action>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label for="Name">
                      <span class="required">*</span> Nome:
                    </label>
                    <input
                      autocomplete="new-password"
                      type="text"
                      id="Name"
                      class="form-control"
                      v-model="type_call.name"
                      placeholder=""
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label><span class="required">*</span> Departamento:</label>
                    <v-select
                      v-model="type_call.department_id"
                      :options="departments"
                      :reduce="(d) => d.id"
                      :label="'name'"
                      placeholder="Selecione um departamento"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="inputUser">
                      <span class="required">*</span> Status:
                    </label>
                    <select v-model="type_call.status" class="form-control">
                      <option :value="1">Ativo</option>
                      <option :value="0">Inativo</option>
                    </select>
                  </div>
                </div>

                <!-- CAMPOS DINÂMICOS -->
                <hr />
                <h6 class="mb-2">
                  <strong>Campos Adicionais do Chamado</strong>
                </h6>
                <p class="text-muted small mb-2">
                  Configure os campos extras que aparecerão ao abrir um chamado
                  deste tipo.
                </p>

                <table
                  class="table table-bordered table-sm mb-2"
                  v-if="type_call.fields.length"
                >
                  <thead class="thead-light">
                    <tr>
                      <th style="width: 50px">Ordem</th>
                      <th>Label</th>
                      <th style="width: 140px">Tipo</th>
                      <th style="width: 90px" class="text-center">
                        Obrigatório
                      </th>
                      <th>Opções (select)</th>
                      <th style="width: 90px" class="text-center">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(field, idx) in type_call.fields">
                      <!-- VIEW ROW -->
                      <tr :key="'view-' + idx" v-if="editingIndex !== idx">
                        <td>{{ field.order }}</td>
                        <td>{{ field.label }}</td>
                        <td>{{ fieldTypeLabel(field.field_type) }}</td>
                        <td class="text-center">
                          <span v-if="field.required" class="badge badge-danger"
                            >Sim</span
                          >
                          <span v-else class="badge badge-secondary">Não</span>
                        </td>
                        <td>
                          <span
                            v-if="
                              field.field_type === 'select' &&
                              field.options &&
                              field.options.length
                            "
                          >
                            {{ field.options.join(", ") }}
                          </span>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-warning mr-1"
                            @click="editField(idx)"
                          >
                            <i class="fa fa-pencil-alt"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            @click="removeField(idx)"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>

                      <!-- EDIT ROW -->
                      <tr :key="'edit-' + idx" v-else class="table-active">
                        <td>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            v-model.number="editingField.order"
                            style="width: 60px"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="editingField.label"
                            placeholder="Label do campo"
                          />
                        </td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            v-model="editingField.field_type"
                          >
                            <option
                              v-for="t in fieldTypes"
                              :key="t.value"
                              :value="t.value"
                            >
                              {{ t.label }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <input
                            type="checkbox"
                            v-model="editingField.required"
                          />
                        </td>
                        <td>
                          <div v-if="editingField.field_type === 'select'">
                            <div
                              v-for="(opt, oi) in editingField.options"
                              :key="oi"
                              class="d-flex mb-1"
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm mr-1"
                                v-model="editingField.options[oi]"
                                placeholder="Opção"
                              />
                              <button
                                type="button"
                                class="btn btn-sm btn-danger"
                                @click="removeOption(oi)"
                              >
                                <i class="fa fa-times"></i>
                              </button>
                            </div>
                            <button
                              type="button"
                              class="btn btn-sm btn-secondary mt-1"
                              @click="addOption"
                            >
                              <i class="fa fa-plus"></i> Opção
                            </button>
                          </div>
                          <span v-else class="text-muted small">—</span>
                        </td>
                        <td class="text-center">
                          <button
                            type="button"
                            class="btn btn-sm btn-success mr-1"
                            @click="confirmField(idx)"
                          >
                            <i class="fa fa-check"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            @click="cancelEdit"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>

                <!-- INLINE NEW FIELD FORM -->
                <div v-if="addingField" class="card card-body bg-light mb-2">
                  <div class="form-row">
                    <div class="form-group col-md-1">
                      <label>Ordem</label>
                      <input
                        type="number"
                        class="form-control form-control-sm"
                        v-model.number="newField.order"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Label <span class="required">*</span></label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="newField.label"
                        placeholder="Ex: Versão do sistema"
                      />
                    </div>
                    <div class="form-group col-md-2">
                      <label>Tipo</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="newField.field_type"
                      >
                        <option
                          v-for="t in fieldTypes"
                          :key="t.value"
                          :value="t.value"
                        >
                          {{ t.label }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group col-md-2 d-flex align-items-end">
                      <div class="form-check mb-2">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          id="newRequired"
                          v-model="newField.required"
                        />
                        <label class="form-check-label" for="newRequired"
                          >Obrigatório</label
                        >
                      </div>
                    </div>
                  </div>
                  <div v-if="newField.field_type === 'select'" class="mb-2">
                    <label>Opções:</label>
                    <div
                      v-for="(opt, oi) in newField.options"
                      :key="oi"
                      class="d-flex mb-1"
                      style="max-width: 400px"
                    >
                      <input
                        type="text"
                        class="form-control form-control-sm mr-1"
                        v-model="newField.options[oi]"
                        placeholder="Opção"
                      />
                      <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="newField.options.splice(oi, 1)"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="newField.options.push('')"
                    >
                      <i class="fa fa-plus"></i> Opção
                    </button>
                  </div>
                  <div>
                    <button
                      type="button"
                      class="btn btn-sm btn-success mr-1"
                      @click="confirmNewField"
                    >
                      <i class="fa fa-check"></i> Confirmar
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="addingField = false"
                    >
                      <i class="fa fa-times"></i> Cancelar
                    </button>
                  </div>
                </div>

                <button
                  type="button"
                  class="btn btn-add btn-sm mb-3"
                  @click="startAddField"
                  v-if="!addingField"
                >
                  <i class="fa fa-plus"></i> Adicionar Campo
                </button>

                <hr />

                <span class="required_fields">
                  <span class="required">*</span>
                  <strong>Campos obrigatórios</strong>
                </span>
                <div class="block text-right mb-1">
                  <router-link to="/type_calls" class="btn btn-back">
                    <i class="fa fa-arrow-left"></i> Voltar
                  </router-link>
                  <a class="btn btn-add ml-1" @click="save">
                    Salvar
                    <i class="fa fa-save"></i>
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "TypeCallAdd",
  data() {
    return {
      type_call: {
        name: "",
        status: "",
        department_id: null,
        fields: [],
      },
      departments: [],
      fieldTypes: [
        { value: "text", label: "Texto" },
        { value: "textarea", label: "Área de texto" },
        { value: "select", label: "Seleção" },
        { value: "checkbox", label: "Caixa de seleção (Sim/Não)" },
        { value: "file", label: "Arquivo" },
        { value: "date", label: "Data" },
        { value: "datetime", label: "Data e Hora" },
        { value: "number", label: "Número" },
      ],
      addingField: false,
      newField: {
        label: "",
        field_type: "text",
        required: false,
        order: 0,
        options: [],
      },
      editingIndex: null,
      editingField: null,
    };
  },
  methods: {
    parseOptions(options) {
      if (Array.isArray(options)) return options;
      if (typeof options === "string") {
        try {
          const parsed = JSON.parse(options);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      return [];
    },

    fieldTypeLabel(value) {
      const found = this.fieldTypes.find((t) => t.value === value);
      return found ? found.label : value;
    },

    startAddField() {
      this.newField = {
        label: "",
        field_type: "text",
        required: false,
        order: this.type_call.fields.length,
        options: [],
      };
      this.addingField = true;
    },

    confirmNewField() {
      if (!this.newField.label.trim()) {
        this.$message("Atenção", "O label do campo é obrigatório.", "error");
        return;
      }
      this.type_call.fields.push({
        ...this.newField,
        options: [...this.newField.options],
      });
      this.addingField = false;
    },

    editField(idx) {
      this.editingIndex = idx;
      const f = this.type_call.fields[idx];
      this.editingField = {
        ...f,
        options: this.parseOptions(f.options),
      };
    },

    confirmField(idx) {
      if (!this.editingField.label.trim()) {
        this.$message("Atenção", "O label do campo é obrigatório.", "error");
        return;
      }
      this.$set(this.type_call.fields, idx, { ...this.editingField });
      this.editingIndex = null;
      this.editingField = null;
    },

    cancelEdit() {
      this.editingIndex = null;
      this.editingField = null;
    },

    removeField(idx) {
      this.type_call.fields.splice(idx, 1);
    },

    addOption() {
      this.editingField.options.push("");
    },

    removeOption(idx) {
      this.editingField.options.splice(idx, 1);
    },

    save() {
      const self = this;
      let api = self.$store.state.api + "type_calls";

      if (self.type_call.id) {
        api += "/" + self.type_call.id;
        self.type_call._method = "PUT";
      }

      const payload = {
        ...self.type_call,
        fields: self.type_call.fields.map((f) => ({
          label: f.label,
          field_type: f.field_type,
          required: f.required,
          order: f.order,
          options: f.options || [],
        })),
      };

      axios
        .post(api, payload)
        .then(() => {
          self.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          self.$router.push("/type_calls");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getTypeCalls(id) {
      const self = this;
      const api = self.$store.state.api + "type_calls/" + id;

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          data.fields = (data.fields || []).map((f) => ({
            ...f,
            options: this.parseOptions(f.options),
          }));
          self.type_call = data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getDepartments() {
      const self = this;
      return axios
        .get(self.$store.state.api + "departments")
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;
    self.getDepartments().then(() => {
      const id = self.$route.params.id;
      if (id) {
        self.getTypeCalls(id);
      }
    });
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
